import addToCart from '../lib/addToCart';
import { closePopup } from '../utils/popupController';
import renderMinicart from '../lib/renderMinicart';
import { SELECTORS } from '../utils/constants';
import updateCart from '../lib/updateCart';

const initAtcForm = (isPopup = false, isQuickOrder = false, closeFn = closePopup, container = document) => {
  const atcForms = container.querySelectorAll('[data-product-form]');
  if (!atcForms.length) return;

  const setBtnLoadingState = (button, spinner, loading) => {
    button.classList.toggle('pointer-events-none', loading);
    button.classList.toggle('opacity-50', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
  };

  const getItem = (form) => {
    const variantId = +form.id.value;
    const quantity = +form.elements['quantity'].value;

    return [variantId, quantity];
  };

  const getAttributes = (form) => {
    const attributeInputs = form.querySelectorAll('input[name^="attributes["]');
    const attributes = {};

    attributeInputs.forEach((input) => {
      const match = input.name.match(/^attributes\[(.+)\]$/);
      if (match) {
        const key = match[1];
        attributes[key] = input.value;
      }
    });
    return attributes;
  };

  const addVariantToCart = async (evt) => {
    evt.preventDefault();
    const submitBtnSpinner = evt.submitter?.querySelector(SELECTORS.LOADING_SPINNER);
    setBtnLoadingState(evt.submitter, submitBtnSpinner, true);
    try {
      const [variantId, quantity] = getItem(evt.target);
      const attributes = getAttributes(evt.target);
      await addToCart(variantId, quantity);
      if (Object.keys(attributes).length) {
        // A failed attributes update must not prevent the minicart opening —
        // the item is already added at this point.
        try {
          await updateCart({ attributes });
        } catch (error) {
          console.error('Error updating cart attributes:', error);
        }
      }
      // The cart page renders its line items and totals server-side — reload it
      // so they reflect the add, instead of re-rendering and opening the
      // minicart over a stale page.
      const cartPageEl = document.querySelector('[data-cart-page]');
      if (cartPageEl) {
        if (isPopup) closeFn();
        window.location.reload();
        return;
      }
      await renderMinicart();
      if (isPopup) closeFn();
      window.theme.minicart?.open();
    } catch (error) {
      console.error('Error adding variant to cart:', error);
    } finally {
      setBtnLoadingState(evt.submitter, submitBtnSpinner, false);
    }
  };

  atcForms.forEach(form => {
    if (form.dataset.atcFormInitialized === 'true') return;
    form.dataset.atcFormInitialized = 'true';
    form.addEventListener('submit', addVariantToCart);
  });
};

export default initAtcForm;
